// import CapabilitiesAndThresholds from "./CapabilitiesAndThresholds";
import EmailAccounts from "./EmailAccounts";
import General from "./General";
import QuoteTemplate from "./QuoteTemplate";
// import StartPlan from "./StartPlan";
import Users from "./Users";
import {
  Link,
  Navigate,
  Outlet,
  Route,
  Routes,
  useMatch,
  useParams,
} from "react-router";
import { getUrl } from "@/lib/useToPage";
import AccountingSystem from "./AccountingSystem";
import { components } from "@/lib/ApiSchema";
import { canAccessSettings } from "@/lib/utils";

export default function Settings({
  user,
}: {
  user: components["schemas"]["LoggedInUserSchema"];
}) {
  const { teamSlug } = useParams();

  if (!canAccessSettings(user, teamSlug)) {
    return <Navigate to={`/teams/${teamSlug}`} replace />;
  }

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Navigate to="general" replace />} />
        {menu.map(({ path, component }) => (
          <Route key={path} path={path} element={component} />
        ))}
      </Route>
      <Route path="*" element={<Navigate to="general" replace />} />
    </Routes>
  );
}

function Layout() {
  return (
    <div className="h-full flex">
      <nav className="min-w-[220px] max-w-[220px] h-full py-6 px-4 flex flex-col gap-4 bg-slate-200">
        <div className="text-lg font-bold">Settings</div>
        <div className="flex flex-col gap-2">
          {menu.map(({ path, label }) => (
            <MenuItem label={label} path={path} key={path} />
          ))}
        </div>
      </nav>
      <div className="h-full grow overflow-y-auto bg-slate-100 p-4">
        <Outlet />
      </div>
    </div>
  );
}

function MenuItem({ label, path }: { label: string; path: string }) {
  const { teamSlug } = useParams();
  const toUrl = `${getUrl("settings", { teamSlug: teamSlug! })}/${path}`;
  const match = useMatch(toUrl);

  return (
    <Link
      to={toUrl}
      className={`text-xs px-4 py-1 ${match ? "bg-blue-200" : ""} cursor-pointer rounded-sm`}
    >
      {label}
    </Link>
  );
}

const menu = [
  { path: "general", component: <General />, label: "General" },
  { path: "users", component: <Users />, label: "Users" },
  {
    path: "quote-template",
    component: <QuoteTemplate />,
    label: "Quote Template",
  },
  {
    path: "email-accounts",
    component: <EmailAccounts />,
    label: "Email Accounts",
  },
  {
    path: "accounting-system",
    component: <AccountingSystem />,
    label: "Accounting System",
  },
  // {
  //   path: "capabilities-thresholds",
  //   component: <CapabilitiesAndThresholds />,
  //   label: "Capabilities & Thresholds",
  // },
  // { path: "plan", component: <StartPlan />, label: "Start Plan" },
];
